import { useMutation } from "@apollo/client";

import {
  GetUserAlertsQuery,
  UpdateAlertStatusInput,
  UpdateAlertStatusMutation,
  UpdateAlertStatusMutationVariables,
} from "../../../../../API";
import { UPDATE_ALERT_STATUS } from "../../../../../common/operations/mutations";
import { GET_USER_ALERTS } from "../../../../../common/operations/queries";

export const useUpdateUserAlertStatus = () => {
  const [updateAlertMutation, { data, loading }] = useMutation<
    UpdateAlertStatusMutation,
    UpdateAlertStatusMutationVariables
  >(UPDATE_ALERT_STATUS);

  const updateAlert = (input: UpdateAlertStatusInput) => {
    return updateAlertMutation({
      variables: {
        input,
      },
      update: (cache, { data }) => {
        if (!data?.updateAlertStatus) {
          return;
        }

        const rows = cache.readQuery<GetUserAlertsQuery>({
          query: GET_USER_ALERTS,
        });

        if (!rows?.getUserAlerts.items.length) {
          return cache.writeQuery({
            query: GET_USER_ALERTS,
            data: {
              getUserAlerts: {
                items: [data?.updateAlertStatus],
                nextToken: null,
                __typename: "ModelAlertConnection",
              },
            },
          });
        }

        const updatedItems = rows.getUserAlerts.items.map(item => {
          if (item?.id === data?.updateAlertStatus?.id) {
            return data?.updateAlertStatus;
          }

          return item;
        });

        cache.writeQuery({
          query: GET_USER_ALERTS,
          data: {
            getUserAlerts: {
              items: updatedItems,
              limit: 0,
              nextToken: rows.getUserAlerts.nextToken ?? null,
              __typename: "ModelAlertConnection",
            },
          },
        });
      },
    });
  };

  return { updateAlert, data, loading };
};
